import { useDispatch, useSelector } from 'react-redux'
import Header from './components/header/Header'
import SideBar from './components/sidebar/SideBar'
import { Flex, Grid } from '@radix-ui/themes'
import { ReactNode, useEffect } from 'react'
import { selectUser, setDarkMode } from './reducers/users'
import TrialHeader from './components/trial-header/TrialHeader'
import { inPov } from './utils/session.ts'
import { HEADER_HEIGHT_WITH_TRIAL, HEADER_HEIGHT_WITHOUT_TRIAL } from './strings/consts.ts'

const App = ({
  children,
  pageName,
  pageTitle = undefined,
  header = <Header pageTitle={pageTitle} />,
}: {
  children: ReactNode
  pageName: string
  pageTitle?: string
  header?: ReactNode
}) => {
  const { session, darkModeEnabled } = useSelector(selectUser)

  localStorage.setItem('DASHBOARD_PAGE_COOKIE', pageName)
  const dispatch = useDispatch()

  const getCookie = (name: string) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? match[2] : undefined
  }
  useEffect(() => {
    const savedDarkMode = getCookie('DARK_MODE')
    if (savedDarkMode !== undefined) {
      dispatch(setDarkMode(savedDarkMode === 'true' ? true : false))
    }
  }, [])

  useEffect(() => {
    if (darkModeEnabled) {
      document.documentElement.classList.add('dark')
      localStorage.setItem('theme', 'dark')
    } else {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('theme', 'light')
    }
  }, [darkModeEnabled])

  return (
    <div className="light dark:dark bg-mainBackground flex">
      {inPov(session) && <TrialHeader povEndDate={session?.portalPreferences?.povEndDate} />}
      {header}
      <Grid
        columns="2"
        gap="3"
        style={{ marginTop: inPov(session) ? HEADER_HEIGHT_WITH_TRIAL : HEADER_HEIGHT_WITHOUT_TRIAL }}
      >
        <Flex direction="column">
          <SideBar />
        </Flex>
        <Flex direction="column">{children}</Flex>
      </Grid>
    </div>
  )
}

export default App
